/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */

import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/admin/token/page',
    method: 'get',
    params: query
  })
}

export function delObj (token) {
  return request({
    url: '/admin/token/' + token,
    method: 'delete'
  })
}

export function stationInfo (stationId) {
  return request({
    url: '/device/data/info/' + stationId,
    method: 'get'
  })
}

export function stationState (stationId) {
  return request({
    url: '/device/data/state/' + stationId,
    method: 'get'
  })
}

export function alarmToday(stationId) {
  return request({
    url: '/device/data/alarm/today/' + stationId ,
    method: 'get'
  })
}

export function electricTrend (stationId) {
  return request({
    url: '/device/data/electric/trend/' + stationId,
    method: 'get'
  })
}

export function electricToday (stationId) {
  return request({
    url: '/device/data/electric/today/' + stationId,
    method: 'get'
  })
}

export function electricSurvey (query) {
  return request({
    url: '/device/data/electric/survey',
    method: 'get',
    params: query
  })
}

export function eleMonthReport (query) {
  return request({
    url: '/device/data/month/report',
    method: 'get',
    params: query
  })
}